// 개인정보 가리기 잠금 API — /api/v2/tenants/me/privacy-mask (티켓 #461)
//
// 해제 암호는 **서버가 판정한다** — 화면으로는 해시조차 내려오지 않는다. 그래서 "친 글자가
// 암호인가"는 여기 unlock 호출로만 알 수 있다.

import { authJson } from "./_client";
import type { PrivacyMaskSettings } from "../../shared/privacy-lock";

const API = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2/tenants/me/privacy-mask`;

/** 매장 설정 — 암호가 정해져 있는지 + 손 떼고 다시 가려지기까지의 분. */
export function fetchPrivacyMaskSettings(): Promise<PrivacyMaskSettings> {
  return authJson<PrivacyMaskSettings>(API);
}

/** 매장대표만 — 해제 암호(빈 문자열이면 삭제)·자동 잠금 시간 저장. */
export function savePrivacyMaskSettings(input: {
  password?: string;
  idleMinutes?: number;
}): Promise<PrivacyMaskSettings> {
  return authJson<PrivacyMaskSettings>(API, {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

/** 친 글자가 해제 암호인지 확인. 틀려도 오류가 아니라 ok:false 다(잠근 티를 내지 않는다). */
export async function checkPrivacyPassword(password: string): Promise<boolean> {
  try {
    const res = await authJson<{ ok: boolean }>(`${API}/unlock`, {
      method: "POST",
      body: JSON.stringify({ password }),
    });
    return res.ok === true;
  } catch {
    // 통신이 막혀도 화면에 아무 말도 띄우지 않는다 — 그냥 안 풀린 것으로 둔다.
    return false;
  }
}
